import { useEffect, useRef, useState } from 'react'

function lerp(start: number, end: number, factor: number) {
  return start + (end - start) * factor
}

export const useSmoothValue = ({
  target,
  factor = 0.1,
  threshold = 0.1,
  skip = false,
}: {
  target: number
  factor?: number
  threshold?: number
  skip?: boolean
}) => {
  const [value, setValue] = useState(target)
  const animated = useRef(value)
  const rafRef = useRef<number | null>(null)

  useEffect(() => {
    if (skip) {
      return
    }
    const update = () => {
      animated.current = lerp(animated.current, target, factor)

      if (Math.abs(animated.current - target) < threshold) {
        animated.current = target
      }

      setValue(animated.current)
      if (animated.current !== target) {
        rafRef.current = requestAnimationFrame(update)
      }
    }

    cancelAnimationFrame(rafRef.current!)
    rafRef.current = requestAnimationFrame(update)

    return () => cancelAnimationFrame(rafRef.current!)
  }, [target, factor, threshold, skip])

  return value
}
